export const percentToDecimal = (percentValue: number, maxValue: number) => {
  return (percentValue / 100) * maxValue;
};

export const decimalToPercent = (decimalValue: number, maxValue: number) => {
  return (decimalValue / maxValue) * 100;
};

export const fixedNumber = (value: number, range: number) => {
  return Number(value.toFixed(range));
};
